<app-login-layout>
  <form
  autocomplete="off"
  class="loginForm ng-valid ng-dirty ng-touched"
  #formRestorePassword="ngForm"
  novalidate
  (ngSubmit)="formRestorePassword.form.valid && onSubmit()"
>
  <div class="loginEmailBox">
    <div class="floatingLabelControl">

      <div class="floatingLabelContainer">
        <div
          class="horizontalLayout floatingLabel floatingLabelShown alignVerticalMiddle"
          id="labelLayout"
        >
          <label class="colAuto">Email</label>
        </div>
      </div>

      <div class="inputLabelContent" id="contentLayout">

          <input
            type="email"
            [(ngModel)]="email"
            name="nombre"
            #emailInput="ngModel"
            [ngClass]="{ 'is-invalid': formRestorePassword.submitted && emailInput.invalid }" required email/>
            <div *ngIf="formRestorePassword.submitted && emailInput.invalid" class="invalid-feedback">
              <div *ngIf="emailInput.errors.required">El email es obligatorio</div>
              <div *ngIf="emailInput.errors.email">El formato del email es incorrecto</div>
          </div>
      </div>
    </div>
  </div>


  <div class="loginSesionButton">

    <button class="buttonPrimary loadingAnimationButton" [className]="loading ? 'loadingAnimationButton' : ''" id="btnLogin" [disabled]="loading">
      <ng-container *ngIf="!loading">Solicitar email de recuperación</ng-container>
      <div class="loadingSpinner" *ngIf="loading"></div>
    </button>
  </div>
  </form>
</app-login-layout>

